module.exports = __webpack_public_path__ + "img/741.82f733c8.jpg";